export interface HttpExceptionBody {
  message?: string;
}

export class HttpException {
  public readonly body?: HttpExceptionBody;

  constructor(
    public readonly response: Response,
    body?: HttpExceptionBody,
  ) {
    if (Array.isArray(body?.message)) {
      this.body = { message: body?.message?.join('\n') };
    } else {
      this.body = body;
    }
  }
}

export const FALLBACK_HTTP_ERROR_MESSAGE = 'Request failed. Please try again.';

// Gateway/proxy errors (5xx HTML pages, empty bodies) reach us without a JSON `message` — without
// this fallback the toast renders the literal string "undefined".
export const resolveHttpErrorMessage = (exception: HttpException): string => {
  const message = exception.body?.message;
  return typeof message === 'string' && message.trim() ? message : FALLBACK_HTTP_ERROR_MESSAGE;
};
